import React from 'react';
import { RouterProvider } from 'react-router-dom';
import JSXRoutes from './routes';
import { Toaster } from 'sonner';
import 'theme/css/index.css';
import './App.css';

import '@zawarski/point-of-distribution/dist/style.css';
import '@zawarski/eti-ui/dist/styles.css';

function App() {
  const routes = JSXRoutes();
  return (
    <React.Fragment>
      <RouterProvider router={routes} />
      <Toaster
        richColors
        duration={3000}
        closeButton
        visibleToasts={10}
        position='top-right'
      />
    </React.Fragment>
  );
}

export default App;
